import dayjs from 'dayjs';

import { useIdentityStore } from '@/stores/identity';
import pinia from '@/stores/pinia';

export function guessTimezone(): string | undefined {
  const guess = dayjs?.tz?.guess();
  // Make sure the timezone is valid (e.g. not Etc/Undefined)
  try {
    dayjs().tz(guess);
    return guess;
  } catch {
    return undefined;
  }
}

export function getTimezoneNames(): string[] {
  return Intl.supportedValuesOf('timeZone') || [];
}

export function getUserTimezone(): string {
  const identityStore = useIdentityStore(pinia);
  // Identity may carry a camelCased `timeZoneName` at runtime that the snake_case type omits.
  const identity = identityStore.identity as
    | (NonNullable<typeof identityStore.identity> & { timeZoneName?: string })
    | null;
  const userTimeZone = identity?.timeZoneName || identity?.time_zone_name;
  return userTimeZone || guessTimezone() || 'UTC';
}
